import { render, staticRenderFns } from "./BrickFilterSettingsEditor.vue?vue&type=template&id=ded3d8d4&scoped=true&"
import script from "./BrickFilterSettingsEditor.vue?vue&type=script&lang=js&"
export * from "./BrickFilterSettingsEditor.vue?vue&type=script&lang=js&"
import style0 from "./BrickFilterSettingsEditor.vue?vue&type=style&index=0&id=ded3d8d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded3d8d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ded3d8d4')) {
      api.createRecord('ded3d8d4', component.options)
    } else {
      api.reload('ded3d8d4', component.options)
    }
    module.hot.accept("./BrickFilterSettingsEditor.vue?vue&type=template&id=ded3d8d4&scoped=true&", function () {
      api.rerender('ded3d8d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Connection/BrickFilterSettingsEditor.vue"
export default component.exports